<script lang="ts">
							import SectionComponent from '$lib/section/SectionComponent.svelte';
							import copy from "copy-to-clipboard"; 
							import { onMount } from "svelte";
							import PrevNextSection from '$lib/prevNext/PrevNextSection.svelte';

							interface ComponentProps {
								setVisible: (id: string, v: boolean) => void;
							}
							let { setVisible }: ComponentProps = $props();
							
							const visibleById = $state<Record<string, boolean>>({});

							/**
               * This function will go through all the 'pre' elements
               * on the page and add a copy button to them.
               * Thanks to: https://slavbasharov.com/blog/adding-click-to-copy-code-markdown-blog
               */
              onMount(() => {
                  const codeBlocks = document.querySelectorAll("pre");
                  codeBlocks.forEach((block) => {
                      const copyPrompt = document.createElement("div");
                      copyPrompt.className = "copy-prompt";
                      const copyPromptText = document.createElement("p");
                      copyPromptText.innerHTML = "👆 Click to copy";
                      copyPromptText.className = 'copy-prompt-p';
                      const copyIcon = document.createElement("img");
                      copyIcon.src = "/icons/copy-icon.svg";
                      copyIcon.className = "copy-prompt-img";
                      copyPrompt.appendChild(copyIcon);
                      copyPrompt.appendChild(copyPromptText);
                      block.appendChild(copyPrompt);
											block.querySelector('.copy-prompt > p')?.addEventListener('click', () => {
												if (block.querySelector('code')?.textContent !== null && block.querySelector('code')?.textContent !== undefined) {
													copy(block.querySelector('code')!.textContent!);
												}
												if (block.querySelector('.copy-prompt > p')?.innerHTML !== null && block.querySelector('.copy-prompt > p')?.innerHTML !== undefined) {
													block.querySelector('.copy-prompt > p')!.innerHTML = 'Copied!';
													setTimeout(() => {
														block.querySelector('.copy-prompt > p')!.innerHTML = '👆 Click to copy';
													}, 1000);
												}
											});
                  });
              });
		let prevLink= '/Tutorial/Validating_the_model';
    let nextLink= '/Examples';
    
</script>
<PrevNextSection {prevLink} {nextLink} />
<SectionComponent tag="h1" 
  id="congratulations-1"
  bind:intersecting={visibleById["congratulations-1"]}
  onIntersectChange={(visible) => setVisible("congratulations-1", visible)}
>Congratulations!!!</SectionComponent>
<p>When you’ve reached this point, you’ve learned all the <strong>basics of Freon</strong>.<br>
Even better—you’ve produced a web-based editor with just <strong>501 lines of code</strong>, containing <strong>9,547 characters</strong>, including comments.<br>
(Yes, we counted them!)</p>
<SectionComponent tag="h2" 
  id="what-to-do-next-2"
  bind:intersecting={visibleById["what-to-do-next-2"]}
  onIntersectChange={(visible) => setVisible("what-to-do-next-2", visible)}
>What to Do Next?</SectionComponent>
<p>There are several directions you can take to continue your Freon journey and explore DSL creation further.</p>
<ul>
<li>Browse through the <a href="/Documentation/Overview">documentation</a>, where many of the topics covered in this tutorial are explained in greater detail.</li>
<li>Dive deeper into the <strong>Computer Aided Learning</strong> DSL by extending it with your own ideas. You’ll find a <a
  href="/Tutorial/Conclusion#ideas-to-extend-the-dsl-3"
>list of suggestions</a> below.</li>
<li>Check out the <a href="/Examples/Overview">examples</a> on this site. Each example focuses on a specific part of Freon. In particular, <a
  href="/Examples/Building_an_Interpreter"
>Building an Interpreter</a> is a great next step, as it builds directly upon the Computer Aided Learning DSL.</li>
<li>Explore the <a href="/LionWeb/Overview">LionWeb</a> section to learn more about <strong>model and language interchange formats</strong> for language engineering tools.</li>
</ul>
<p>And if you’ve truly caught the Freon spirit—consider joining the <strong>team of contributors</strong>!</p>
<SectionComponent tag="h2" 
  id="ideas-to-extend-the-dsl-3"
  bind:intersecting={visibleById["ideas-to-extend-the-dsl-3"]}
  onIntersectChange={(visible) => setVisible("ideas-to-extend-the-dsl-3", visible)}
>Ideas to Extend the DSL</SectionComponent>
<p>We conclude this tutorial with a few ideas for extending the <strong>Computer Aided Learning DSL</strong>:</p>
<ul>
<li>Introduce questions that can have <strong>boolean answers</strong>,<br>
e.g. “Can this fraction be simplified: 13/139?”</li>
<li>Experiment with <strong>styling</strong> to change the appearance of your editor.<br>
See the documentation on <a
  href="/Documentation/Defining_an_Editor/Styling"
>styling</a>.</li>
</ul>
<p>Congratulations once again—and happy language engineering with Freon!</p>


<PrevNextSection {prevLink} {nextLink} />